import Vue from 'vue'
import Router from 'vue-router'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from './services/store'
import Nprogress from 'nprogress'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base:'',// process.env.BASE_URL,
  routes: [    
    {
      path: '/',
      name: 'Loader',
      component:()=>import('./components/Loader'),
      },
      {
      path: '/home',
      name: 'home',
      component:()=>import('./views/Home'),
      meta: {
        isPublic:false,
        requiresAuth: true
      },
      children:[
        {
          path: "view-users",
          name: 'ViewUsers',
          component:()=>import('./views/Users/ViewUsers'),
          meta: {
            requiresAuth: true,
            title: 'View Users'
          }
        },{
          path: "user-claims",
          name: 'UserClaims',
          component: ()=>import('./views/UserClaims/UserClaims'),
          meta: {
            requiresAuth: true,
            title: 'User Claims'
          },
        },{
          path: "role-claims",
          name: 'RoleClaims',
          component: ()=>import('./views/RoleClaims/RoleClaims'),
          meta: {
            requiresAuth: true,
            title: 'Role Claims'
          },
        },{
          path: "view-roles",
          name: 'ViewRoles',
          component: ()=>import('./views/Roles/ViewRoles'),
          meta: {
            requiresAuth: true,
            title: 'View Roles'
          }
        },
        {
          path: "view-tenants",
          name: 'Tenants',
          component: ()=>import('./views/Tenants/Tenants'),
          meta: {
            requiresAuth: true,
            title: 'Tenant Management'
          }
        },
        {
          path: "external-providers",
          name: 'External Providers',
          component: ()=>import('./views/ExternalProviders/ExternalProviders'),
          meta: {
            requiresAuth: true,
            title: 'External Providers '
          }
        },{
          path: "tenant-external-providers",
          name: 'Tenant External Providers',
          component: ()=>import('./views/TenantExternalProviders/TenantExternalProviders'),
          meta: {
            requiresAuth: true,
            title: 'External Providers '
          }
        },{
          path: "view-clients",
          name: 'Clients',
          component: ()=>import('./views/Clients/Clients'),
          meta: {
            requiresAuth: true,
            title: 'Client Management'
          }
        },
        {
          path: "*",
          name: 'LandingPage',
          component:()=>import('./components/Home') ,
          meta: {
            requiresAuth: true,
            title: 'Home Page'
          }
        },
      ]
    },
    {
      path: '/login',
      name:"login",
      meta: {
        requiresAuth: true
      },
      component: ()=>import('./views/LoginLoad'),
    },
    {
      path: '/callback1',
      name: 'callback',
      meta: {
        requiresAuth: true
      },
      component: ()=>import('./views/Callback'),
    },
    {
      path: '/silent-renew-oidc', // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings
      name: 'oidcSilentRenew',
      component: ()=>import('./components/OidcSilentRenewal'),
      meta: { title: 'oidcSilentRenew', isPublic: true }

    },{
      path: '/callback', // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings
      name: 'oidcCallback',
      component: ()=>import('./views/OidcCallback'),
      meta: { title: 'Login', isPublic: true }
    },
    {
      path: '/logoutSuccess',
      name: 'Logout',
      component: ()=>import('@/components/LogoutSuccess.vue'),
      meta: {  title: 'Logout', isPublic: true }
    },
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: ()=>import('./views/Unauthorized')
    },
    {
      path: '/*',
      component: ()=>import('./components/404')
      },
  ]
})

export default router;


// router.beforeEach(async (to, from, next) => {
// //  setTimeout(function(){
// console.log(next);
//   let app = router.app.$data || {isAuthenticated: false}
  
//   if (app.isAuthenticated) {
//     //already signed in, we can navigate anywhere
//     console.log("isAuthenticated");
//     next()
//   } else if (to.matched.some(record => record.meta.requiresAuth)) {
//     // authentication is required. Trigger the sign in process, including the return URI
//     let authenticate = router.app.authenticate
//     debugger
//     console.log("Navigate to login");
//     if(authenticate!=undefined){
//       authenticate(to.path).then(() => {
//         console.log('authenticating a protected url:' + to.path);
//         next()
//       });
//     // next("")
//     }
//     else 
//     next("/")

//   }
//    else {
     
//     console.log("NO auth required");
//     //No auth required. We can navigate
//     next()
//   }
// //  },2000);
// });



router.beforeEach(vuexOidcCreateRouterMiddleware(store))


router.beforeResolve((to, from, next) => {
  if (to.name) {
    Nprogress.start()
  }
  next()
});

router.afterEach(() => {
  Nprogress.done()
});